export const siteConfig = {
  name: "Global Payroll Migration",
  title: "Global Payroll Migration - UK Payroll Migration Specialists",
  description: "UK-Based Payroll Migration Specialists for Seamless Global Transitions. Expert payroll migration services with zero downtime guarantee.",
  url: "https://globalpayrollmigration.com",
  ogImage: "/images/gpm-logo.png",
  links: {
    linkedin: "https://linkedin.com/company/global-payroll-migration",
    twitter: "https://twitter.com/globalpayrollmig"
  },
  creator: "Global Payroll Migration",
  keywords: [
    "payroll migration",
    "payroll services",
    "UK payroll migration",
    "global payroll",
    "payroll consultancy",
    "enterprise payroll",
    "SME payroll services",
    "payroll compliance",
    "payroll automation",
    "HR technology migration"
  ],
  type: "website",
  language: "en-GB",
  locale: "en_GB",
  businessInfo: {
    name: "Global Payroll Migration",
    type: "Organization",
    foundingDate: "2020",
    address: {
      streetAddress: "London",
      addressLocality: "London",
      addressRegion: "England",
      addressCountry: "GB"
    },
    contactPoint: {
      telephone: "+44-xxx-xxx-xxxx",
      contactType: "customer service",
      availableLanguage: ["English"]
    },
    sameAs: [
      "https://linkedin.com/company/global-payroll-migration"
    ]
  }
};
